<div [class]="'symbol symbol-35px ' + symbolClass()">
  <span [class]="'symbol-label ' + 'bg-light-' + severity()">
    <ui-keenicon
      [name]="iconName()"
      [class]="'fs-2 ' + 'text-' + severity()"
    ></ui-keenicon>
  </span>
</div>
